import React from "react";
import "./style.css";
import CustomCard from "../../../../../dentail-indetifcation/components/d-reusable/CustomCard";

const CaseBreakdown = ({ data }) => {
  const caseData = [
    {
      group: "Children",
      count: data?.children_projects || 0,
      color: "#dcf6f2",
      dotColor: "#dcf6f2",
    },
    {
      group: "Juvenile",
      count: data?.juvenile_projects || 0,
      color: "#fbecc0",
      dotColor: "#fbecc0",
    },
    {
      group: "Adolescent",
      count: data?.adolescent_projects || 0,
      color: "#fccfc0",
      dotColor: "#fccfc0",
    },
    {
      group: "Adult",
      count: data?.adult_projects || 0,
      color: "#d4d3fd",
      dotColor: "#d4d3fd",
    },
  ];

  const totalProjects = data?.total_projects || 1; // Avoid division by zero

  const getPercentage = (count) => (count / totalProjects) * 100;

  const gradientStops = caseData.reduce((acc, item, index) => {
    const prevValue = index === 0 ? 0 : acc[index - 1].end;
    const percentage = getPercentage(item.count);
    return [
      ...acc,
      { color: item.color, start: prevValue, end: prevValue + percentage },
    ];
  }, []);

  const gradientBackground = `conic-gradient(${gradientStops
    .map((stop) => `${stop.color} ${stop.start}% ${stop.end}%`)
    .join(", ")})`;

  return (
    <CustomCard>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 10px",
        }}
      >
        <h6
          style={{
            padding: 0,
            margin: 0,
            fontSize: 18,
            fontFamily: "Poppins-Medium",
          }}
        >
          Case Breakdown
        </h6>
      </div>
      <div className="cases-container">
        <div className="cases-breakdown-box">
          <div className="chart-container">
            <div
              className="donut-chart"
              style={{ background: gradientBackground }}
            >
              <div className="total-cases">
                <div className="total-label">Total Cases</div>
                <div className="total-count">{data?.total_projects}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="legend-container">
          {caseData.map((item, index) => (
            <div key={index} className="legend-item">
              <div
                className="color-indicator"
                style={{ backgroundColor: item.color }}
              ></div>
              <div className="group-name">{item.group}</div>
              <div className="group-count">
                {item.count.toString().padStart(2, "0")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </CustomCard>
  );
};

export default CaseBreakdown;
